<template>
  <el-container class="organization">  
    <div class="headerCom"> 
      <publicBreadCrumb  :breadList="breadList"/> 
    </div>
    <!-- 内容 -->
    <el-main class="organization-content">
      <!-- 中间列表数据 -->
      <el-tabs v-model="activeNameall" @tab-click="alllistinfo">
        <!-- 全部 -->
        <el-tab-pane label="全部" name="one">
          <el-table :data="alllist" style="width: 100%">
            <el-table-column label="序号" prop="date" type="index" show-overflow-tooltip fixed> </el-table-column>
            <el-table-column label="日志标题" prop="title" show-overflow-tooltip> </el-table-column>
            <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip> </el-table-column>
            <el-table-column label="创建用户id" prop="createUserId" show-overflow-tooltip width="90"> </el-table-column>
            <el-table-column label="异常信息" prop="exception" show-overflow-tooltip> </el-table-column>
            <el-table-column label="操作方式" prop="method" show-overflow-tooltip> </el-table-column>
            <el-table-column label="备注" prop="note" show-overflow-tooltip> </el-table-column>
            <el-table-column label="请求参数" prop="params" show-overflow-tooltip> </el-table-column>
            <el-table-column label="操作IP地址" prop="remoteAddr" show-overflow-tooltip width="90"> </el-table-column>
            <el-table-column label="请求URL" prop="requestUri" show-overflow-tooltip> </el-table-column>
            <el-table-column label="服务id" prop="serviceId" show-overflow-tooltip> </el-table-column>
            <el-table-column label="正常/异常" prop="success" show-overflow-tooltip width="90"> </el-table-column>
            <el-table-column label="执行时间" prop="time" show-overflow-tooltip> </el-table-column>
            <el-table-column label="用户代理" prop="userAgent" show-overflow-tooltip> </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <!-- 分页 -->
      <div class="cardpage">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total,  prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { api_feign_log } from "@/api/logamanage.js";  
import local from "@/utils/local.js";
export default {
  data() {
    return {
      breadList:[{name:'系统设置'},{name:'日志管理'}],
      pageSize: 10, //每页条数
      currentPage: 1, // 初始显示那一页
      total: 10, // 总条数
      input: "", //搜索组件
      value1: "", //选择日期组件
      pickerOptions: {
        shortcuts: [
          {
            text: "7天内",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "3天内",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "一天内",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "全部",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1800);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      }, //日期选择组件 时间差查询
      alllist:[],//全部列表数据
      activeNameall:"one",
    }
  },
  methods: {
    async getfeignlog() {
      let res = await api_feign_log({
        current:this.currentPage,
        size:this.pageSize,

      });
      this.total = res.data.totalPages
      this.alllist = res.data.content
    },
    //标签点击切换触发事件
    alllistinfo(){},
    //输入内容触发事件
    contentinfo(){},
    //切换分页触发事件
    handleSizeChange(val){
      this.currentPage = val;
      this.getfeignlog();
    },
    //切换分页触发事件
    handleCurrentChange(val){
      this.currentPage = val;
      this.getfeignlog();
    },
    //项目类型下拉筛选触发事件
    handleCommandone(){},
    //立项事件下拉筛选触发事件
    handleCommandtwo(){},
    //选择时间触发事件
    dateinfo(){},
    //查看申请按钮
    handleClick(){},
    //通过按钮
    handleClickon(){},
    //驳回按钮
    handleClickoff(){},
    //状态改变
    statusFormatter(){},
  },
  mounted () {
    this.getfeignlog();
  },
};
</script>

<style lang="less" scoped>
.organization {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
    .organization-top-person {
      font-weight: bolder; 
    } 
    .organization-top-btn {
      margin-left: 35px;
      margin-top: 25px;
      /deep/.el-dropdown {
        margin-left: 20px;
        .el-button {
          border-radius: 20px;
        }
      }
    }
    .organization-top-date {
      margin-left: 35px;
      line-height: 90px;
      .el-date-editor {
        border-radius: 20px;
        border-color: skyblue;
      }
    } 
  .organization-content { 
    background-color: #fff;
    border-radius: 5px; 
    box-sizing: border-box;
    padding: 10px 20px;
    margin: 0 16px;
    .organization-content-top {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ccc;
      line-height: 50px;
      .left {
        display: flex;
        div {
          margin-right: 15px;
        }
      }
    }
    .organization-content-toptwo {
      margin-top: 20px;
      border-bottom: 1px solid #ccc;
      .top {
        display: flex;
        div {
          width: 25%;
        }
        .el-button {
          padding: 5px 10px !important;
        }
      }
      .bottom {
        margin-bottom: 15px;
        margin-top: 15px;
        display: flex;
        div {
          width: 25%;
        }
        .el-button {
          padding: 5px 10px !important;
        }
      }
    }
    .organization-content-list {
      margin-top: 15px;
    }
    .cardpage {
      margin-top: 20px;
      text-align: right;
    }
    .department-add {
      .title {
        font-size: 26px;
        text-align: center;
        margin-bottom: 15px;
      }
      /deep/.el-drawer__body {
        overflow-y: scroll;
        height: 100%;
      }
      .from_btn {
        text-align: right;
        margin-bottom: 10px;
      }
      .imgup {
        /deep/.el-upload {
          height: 70px;
          width: 70px;
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>